export default function Bio() {
  return (
    <div className="bio">
     {/* <p>idk i just work here</p> */}
      <p>I am good at what I do, and what I do is live life with passion and enthusiasm. I express this in my work. Its a creative and intellectual outlet. I couldn't think of a better job. I am eager to have more challenging work on my plate. Challenge my abilities. Lets connect.</p>
    </div>
  )
}
